export default {
  styleOverrides: {
    root: {
      backgroundColor: "#1E1E2E",
    },
  },
};